module.exports = __webpack_public_path__ + "img/CAB79D_F9F1E3_F1E5D1_E9DAC6-256px.f08bdb23.png";